import values from 'lodash/values';
import PropTypes from 'prop-types';
import React from 'react';

import QATags from '../../../../constants/QATags';
import { createBEM } from '../../../../lib/utils/css';
import SourceCard from '../../SourceCard/SourceCard';
import { RowItemEllipsisActions } from '../constants';

import './RowItemEllipsis.scss';

function shouldRenderEllipsis(props) {
  return !props.isClickableRow && props.sourceCardMenuItems && props.enableSourceCardMenu;
}

const RowItemEllipsis = React.memo(props => {
  if (!shouldRenderEllipsis(props)) {
    return null;
  }

  const {
    useDarkTheme,
    sourceCardMenuItems,
    sourceCardToggleCallback,
    triggerHidden,
    qaEllipsis,
    onShuffle,
  } = props;

  const classNames = createBEM('RowItemEllipsis', {
    onShuffle,
  });

  return (
    <div className={classNames}>
      <SourceCard
        isEllipsis={true}
        isEllipsisSmall={true}
        isDark={useDarkTheme}
        tooltipOnEllipsis={true}
        type={RowItemEllipsisActions}
        sourceCardMenuItems={sourceCardMenuItems}
        onToggleActive={sourceCardToggleCallback}
        triggerHidden={triggerHidden}
        qaTag={qaEllipsis}
      ></SourceCard>
    </div>
  );
});

RowItemEllipsis.propTypes = {
  onShuffle: PropTypes.bool,
  qaEllipsis: PropTypes.oneOf(values(QATags)),
  sourceCardMenuItems: PropTypes.array,
  sourceCardToggleCallback: PropTypes.func,
  triggerHidden: PropTypes.bool,
  useDarkTheme: PropTypes.bool,
};

export default RowItemEllipsis;
